module.exports = __webpack_public_path__ + "static/img/idcard2.bf7f41e9.png";